import { FormikHelpers } from 'formik';

export const setFieldError = <T extends unknown>(key: keyof T, error: string, helpers: FormikHelpers<T>) => {
	helpers.setFieldError(key as string, error);
};
